import { Animator, ScrollContainer, ScrollPage, Sticky, Fade, batch, MoveOut, ZoomIn, FadeIn, StickyIn, MoveIn } from 'react-scroll-motion';
import './ScrollTextStyles.css';
import { useTranslation} from "react-i18next";


const ZoomInScrollOut = batch(StickyIn(),FadeIn(),ZoomIn());
const FadeUpRight = batch(Fade(),Sticky(),MoveIn(1000,0));
const FadeUpLeft = batch(Fade(),Sticky(),MoveIn(-1000,0));

const ScrollText = () =>{
    const { t } = useTranslation('common');

    return(
        <div className='section-scroll'>
<ScrollContainer >
    <ScrollPage page={0}>
                <Animator animation={batch(Sticky(),Fade(),MoveOut(0,-200))}>
                    <div className='presentation-title-test'>
                            <h1> {t('presentation_edition.presentation')}</h1>
                    </div>
                
                </Animator>
            </ScrollPage>
            <ScrollPage page={1}>
                <Animator animation={batch(Sticky(),Fade(),MoveOut(0,-200))}>
                    <h2> {t('presentation_edition.le_temps')}</h2>
                </Animator>
            </ScrollPage>

            <ScrollPage page={2}>
                <Animator animation={FadeUpRight}>
                    <h2> {t('presentation_edition.près_de')} </h2>
                </Animator>
            </ScrollPage>
            <ScrollPage page={3}>
                <Animator animation={FadeUpLeft}>
                    <h2> {t('presentation_edition.pour')} </h2>
                </Animator>
            </ScrollPage>
            <ScrollPage page={4}>
                <Animator animation={ZoomInScrollOut}>
                    <h2> {t('presentation_edition.19_sports')} </h2>
                </Animator>
            </ScrollPage>
            <ScrollPage page={5}>
            <Animator animation={batch(Sticky(),MoveIn(0,100),Fade())}>
                    <h2> {t('presentation_edition.ainsi_qu')} </h2>
                </Animator>
            </ScrollPage>
            <ScrollPage page={6}>
            <Animator animation={ZoomInScrollOut}>
                    <h2> {t('presentation_edition.activités_mises')}</h2>
                </Animator>
            </ScrollPage>
            
            
            
        </ScrollContainer>

        </div>
        
    )
}

export default ScrollText